import { useMutation, useQuery } from "@tanstack/react-query"
import {
  emailPartnerReport,
  fetchPartnerReportPdf,
  type EmailPartnerReportRequest,
  type PartnerReportRequest,
} from "../api/partner-materials-report.api"

export function usePartnerReportPdf(request: PartnerReportRequest, enabled: boolean) {
  return useQuery({
    queryKey: [
      "reports",
      "partner-materials",
      "pdf",
      request.regionId,
      request.organizationName,
      request.filters.workscopes,
      request.filters.dateCompletedFrom,
      request.filters.dateCompletedTo,
    ],
    queryFn: () => fetchPartnerReportPdf(request),
    enabled: enabled && request.regionId > 0 && Boolean(request.organizationName),
    staleTime: 0,
    gcTime: 0,
    retry: false,
  })
}

export function useEmailPartnerReport() {
  return useMutation({
    mutationFn: (request: EmailPartnerReportRequest) => emailPartnerReport(request),
  })
}

